import { inject, Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { ApiService } from '../../../../core/services/ApiService';
import { Observable, tap } from 'rxjs';
import { IResponse } from '../../../../core/interfaces/IResponse';
import { IWeather } from '../interfaces/IWeather';
import { DashboardStore } from '../stores/DashboardStore';
import { nonBlocking } from '../../../../core/http/non-blocking.context';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  private readonly _basePath = '/dashboard';
  private readonly _apiService = inject(ApiService);
  private readonly _dashboardStore = inject(DashboardStore);

  public getWeather(): Observable<IResponse<IWeather>> {
    return this._apiService.get(`${this._basePath}/weather`, new HttpParams(), nonBlocking())
      .pipe(
        tap(res => this._dashboardStore.weather.set(res?.data ?? null))
      );
  }
}
